import { HeadCogOutlineIcon } from './HeadCogOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C4C50873-9844-42F6-A37B-16FE905873D9
 * name head-cog-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-cog-outline.svg
 * tags
 * - Settings 
 */
export const PsychologyOutlineIcon = HeadCogOutlineIcon;
export default PsychologyOutlineIcon